var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidenavEmbelishment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 196.001,
    height: 400.388,
    viewBox: "0 0 196.001 400.388",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rljygf391a",
    x1: 0.809,
    y1: 0.345,
    x2: 0.779,
    y2: 0.095,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef0f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Side nav_embelishment 1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Intersection 59",
    d: "m5318.817 538.957 112.993 50.307a80 80 0 0 1 40.545 105.623L5384.5 892.214a79.97 79.97 0 0 1-65.682 47.132z",
    transform: "translate(-5318.816 -538.957)",
    style: {
      fill: "url(#rljygf391a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Intersection 60",
    d: "m5111.425 952.888-36.253-16.9A79.722 79.722 0 0 1 5035 893.92v-60.886q.7-1.692 1.478-3.365l20.286-43.5a80 80 0 0 1 106.314-38.7l36.251 16.9A79.635 79.635 0 0 1 5231 790.9v94.856l-13.261 28.44a79.941 79.941 0 0 1-106.314 38.7z",
    transform: "translate(-5034.999 -578.957)",
    style: {
      fill: "url(#rljygf391a)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidenavEmbelishment);
export default __webpack_public_path__ + "static/media/sidenav-embelishment.6b8b50f7e93f421470e287006a5ff3e5.svg";
export { ForwardRef as ReactComponent };